export default "__VITE_ASSET__BncI6t6U__"